import * as React from 'react'
import Modal, { Sizes as ModalSizes } from '../../atoms/Modal/Modal'
import Styles, { CardContent } from './ProductTypeDialog.style'
import CheckSvg from '../../atoms/Icons/Button/Check'
import Button from '../../atoms/Button/Button'
import RadioButton from '../../atoms/RadioButton/RadioButton'
import Card from '../../atoms/Card/Card'

type Props = {
  onStartStaticPricedDraft: () => void
  onStartVariablePricedDraft: () => void
  isOpen: boolean
  onClose: () => void
}

const variablePricedProductImage = (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H52C58.6274 0 64 5.37258 64 12V52C64 58.6274 58.6274 64 52 64H12C5.37258 64 0 58.6274 0 52V12Z"
      fill="#F0F0F0"
    />
    <rect width="64" height="64" rx="12" fill="#F0F0F0" />
    <path d="M13 28C13 25.7909 14.7909 24 17 24H33C35.2091 24 37 25.7909 37 28V52H13V28Z" fill="#B0A0E9" />
    <path d="M27 16C27 13.7909 28.7909 12 31 12H47C49.2091 12 51 13.7909 51 16V52H27V16Z" fill="#F3B4B3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.9997 51.9995H27V24H32.9997C35.2088 24 36.9997 25.7909 36.9997 28V51.9995Z"
      fill="#A94D64"
    />
  </svg>
)

const staticPricedProductImage = (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" rx="12" fill="#F0F0F0" />
    <ellipse cx="38" cy="39.5" rx="14" ry="13.5" transform="rotate(-180 38 39.5)" fill="#EC999F" />
    <circle cx="27" cy="26" r="16" transform="rotate(-180 27 26)" fill="#C5B7F4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 26C30.268 26 24 32.0442 24 39.5C24 40.2683 24.0666 41.0216 24.1944 41.7548C25.1053 41.916 26.0428 42 27 42C35.5421 42 42.5207 35.3061 42.9763 26.8777C41.4301 26.3106 39.7526 26 38 26Z"
      fill="#4F409D"
    />
  </svg>
)

/**
 * Choose Product popup organism
 * @param {object} props Component props
 * @param {string } props.onStartStaticPricedDraft Callback starting a draft with static priced product
 * @param {string } props.onStartVariablePricedDraft Callback for starting a draft with performance based product
 * @param {boolean} props.isOpen Whether the modal is open or not
 * @param {function} props.onClose Callback for closing the modal
 */

const ProductTypeDialog = ({ onStartStaticPricedDraft, onStartVariablePricedDraft, isOpen, onClose }: Props) => {
  const [selectedOption, setSelectedOption] = React.useState(null)

  const onStart = () => {
    if (selectedOption === 1) {
      onStartStaticPricedDraft()
    } else {
      onStartVariablePricedDraft()
    }
  }

  return (
    <Modal isOpen={isOpen} handleClose={onClose} size={ModalSizes.large}>
      <Styles>
        <header className="header">
          <h2>Kies je vacaturepakket</h2>
          <h3>Selecteer een vaste pakketprijs of betaal op basis van je resultaten.</h3>
        </header>

        <section className="choose-product-container">
          <Card
            selected={selectedOption === 1}
            onClick={() => setSelectedOption(1)} 
            data-testid="prod-type-1"
          >
            <CardContent>
              <RadioButton
                id="product-1"
                label=""
                name=""
                checked={selectedOption === 1}
                onChange={() => {}}
                className="radio-button"
              />
              <header>
                {staticPricedProductImage}
                <aside>
                  <h3>Vaste pakketprijs</h3>
                  <p>Betaal één vast bedrag</p>
                </aside>
              </header>

              <hr />

              <footer>
                <p>
                  <CheckSvg /> Stel zelf je pakket samen{' '}
                </p>
                <p>
                  <CheckSvg /> Kies eventueel extra promotie{' '}
                </p>
              </footer>
            </CardContent>
          </Card>

          <Card 
            selected={selectedOption === 2} 
            onClick={() => setSelectedOption(2)}
            data-testid="prod-type-2"
          >
            <CardContent>
              <RadioButton
                id="product-2"
                label=""
                name=""
                checked={selectedOption === 2}
                onChange={() => {}}
                className="radio-button"
              />
              <header>
                {variablePricedProductImage}
                <aside>
                  <h3>Variabele prijs</h3>
                  <p>Betaal per sollicitatie click</p>
                </aside>
              </header>

              <hr />

              <footer>
                <p>
                  <CheckSvg /> Kies je max prijs of solliciteer clicks{' '}
                </p>
                <p>
                  <CheckSvg /> Inclusief promotieplan{' '}
                </p>
              </footer>
            </CardContent>
          </Card>
        </section>

        <footer>
          <Button 
            size={Button.Sizes.large} 
            onClick={onStart} 
            disabled={typeof selectedOption !== 'number'}
            data-testid="confirm-job-type"
          >
            Start Vacature
          </Button>
        </footer>
      </Styles>
    </Modal>
  )
}

export default ProductTypeDialog
